/**
 * ENG-282: the right-hand Events / Alerts / AI Intelligence panel is hidden for
 * the ArduPilot conference. The AI chat is broken and the feeds are dev-facing,
 * so we'd rather not give them a third of the screen. Nothing was deleted; set
 * this to `true` to bring the panel back. The Debug Logs tab still shows in
 * debug mode. Alecia is redesigning this area in Nov/Dec.
 */
export const RIGHT_PANEL_ENABLED = false;
